<template>
  <v-card>
    <v-card-title>
      <v-col>
        <v-row>
          <span class="text-h5"
            >{{ $t('APARTMENTS.ITEM') }} {{ apartment.name }}</span
          >
        </v-row>
        <v-row v-if="buildings.length === 1">
          <span class="text-h5">
            ({{ buildings[0].street }}, {{ buildings[0].name }})
          </span>
        </v-row>
      </v-col>
    </v-card-title>

    <v-card-text>
      <div v-if="error">
        <v-alert
          v-for="(e, index) in error.data.errors"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ e[0] }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <apartment-form v-model="newApartment" readonly>
          <template v-slot:buttons>
            <v-layout align-center justify-space-between row>
              <v-btn outlined text @click="$emit('cancel')">{{
                $t('BUTTON.CANCEL')
              }}</v-btn>
              <v-btn color="primary" @click="edit">{{
                $t('BUTTON.EDIT')
              }}</v-btn>
            </v-layout>
          </template>
        </apartment-form>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import ApartmentForm from '@/components/apartments/components/ApartmentForm';

export default {
  name: 'ApartmentEdit',

  components: { ApartmentForm },

  props: {
    buildings: {
      type: Array,
      required: true
    },

    apartment: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    newApartment: {
      presentation: false
    },
    error: null,
    valid: true
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    this.newApartment = { ...this.apartment };
  },

  methods: {
    edit() {
      this.$emit('edit');
      this.$emit('cancel');
    }
  }
};
</script>
